import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CartMinimalGeoCode } from 'cart-core';
import { PACKAGE_NAME, SHIPPING_STORAGE_KEY } from '../constants';
import { RootState, Shipping } from '../types';
import api from '../api';

const initialState: Shipping = JSON.parse(
    window.localStorage.getItem(SHIPPING_STORAGE_KEY)
) ?? {
    city: '',
    country: '',
    geoCode: '',
    postalCode: '',
    state: '',
};

const slice = createSlice({
    name: `${PACKAGE_NAME}/shipping` as const,
    initialState,
    reducers: {
        setShippingCity: (state, action: PayloadAction<string>) => {
            state.city = `${action.payload}`;
            state.geoCode = null;
        },

        setShippingCountry: (state, action: PayloadAction<string>) => {
            state.country = `${action.payload}`;
        },

        setShippingGeoCode: (state, action: PayloadAction<CartMinimalGeoCode>) => {
            if (
                action.payload == null ||
                !action.payload.state ||
                !action.payload.city ||
                !action.payload.geoCode
            ) {
                state.geoCode = '';
                state.state = '';
                state.city = '';
                return;
            }
            state.geoCode = `${action.payload.geoCode}`;
            state.state = `${action.payload.state}`;
            state.city = `${action.payload.city}`;
        },

        setShippingPostalCode: (state, action: PayloadAction<string>) => {
            state.postalCode = `${action.payload}`;
            state.geoCode = '';
        },

        setShippingState: (state, action: PayloadAction<string>) => {
            state.state = `${action.payload}`;
            state.geoCode = '';
        },
    },
    extraReducers: (build) => build
        .addMatcher(
            api.endpoints.findCurrentCountryRule.matchFulfilled,
            (state, action) => {
                if (!state.country) {
                    state.country = action.payload.countryIso3Code
                }
            }
        )
});

export default slice.reducer;
export const { name } = slice;
export const {
    setShippingCity,
    setShippingCountry,
    setShippingGeoCode,
    setShippingPostalCode,
    setShippingState,
} = slice.actions;

export const selectShipping = (state: RootState) => state[slice.name];

export const selectShippingCity = (state: RootState) =>
    state[slice.name].city;

export const selectShippingCountry = (state: RootState) =>
    state[slice.name].country;

export const selectShippingGeoCode = (state: RootState): CartMinimalGeoCode => (
    state[slice.name].geoCode != null ? ({
        city: state[slice.name].city,
        geoCode: state[slice.name].geoCode,
        state: state[slice.name].state,
    }) : null
);

export const selectShippingState = (state: RootState) =>
    state[slice.name].state;

export const selectShippingPostalCode = (state: RootState) =>
    state[slice.name].postalCode;
